import * as Yup from 'yup';

export const WELCOME_VALIDATION_SCHEMA = Yup.object({
  mood: Yup.number().optional(),
});
